var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayDisclaimer)?_c('div',{staticClass:"disclaimer-container"},[_c('v-container',{staticClass:"px-sm-7 pt-6"},[_c('sc-rich-text',{attrs:{"field":this.fields.DisclaimerText,"editable":false}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }